import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, Input, Alert } from 'reactstrap'

export default class PropertyTableForm extends React.Component {

    onSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            const result = this.props.calcFormula({ ...this.props.values }) // Calcul
            switch (this.props.type) {
                case 'P2O5':
                    result.result = `P2O5 Concentration : ${result.percentage} %`
                    break
                case 'H2SO4_PROPERTY':
                    result.result = `H2SO4 Concentration : ${result.percentage} %`
                    break
                case 'PHYSICAL_PROPERTY':
                    result.result = `Absolute pressure : ${result.absolutePressure} bar; Temperature : ${result.temperature} °C; Specific volume : ${result.specificVolume} m³/Kg; Vaporisation heat : ${result.vaporisationHeat} kcal/Kg `
                    break
                case 'EBULLITION':
                        result.result = `Absolute pressure required: ${result.pressure} mbar`
                    break
                case 'H2SiF6':
                    result.result = `H2SiF6 Concentration : ${result.percentage} %`
                    break
                default:
                    break
            }
            this.props.valueToState({ ...result, hasError: false, hasResult: true }) // Redux

        } catch (e) {
            console.log(e)
            this.props.valueToState({ hasError: true, hasResult: false })
        }
    }

    render() {
        return (
            <Form onSubmit={this.onSubmit}>
                <FormGroup>
                    {this.props.children}
                </FormGroup>
                {/** Submit */}
                <Input type="submit" value={this.props.btnName} className="custom-button" onClick={this.onSubmit} />
                <br />
                {/** Résultat */}
                {this.props.values.hasResult ?
                    <div className="formula-result text-center">
                        {this.props.values.result}
                    </div>
                    : null}
                {this.props.values.hasError ?
                    <div className="text-center">
                        <Alert color="danger">
                            Error while calculating
                        </Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}
PropertyTableForm.propTypes = {
    values: PropTypes.object,
    valueToState: PropTypes.func,
    calcFormula: PropTypes.func,
    children: PropTypes.node,
    btnName: PropTypes.string,
    type: PropTypes.string
}